"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformVehiclesToString = transformVehiclesToString;
function transformVehiclesToString(vehicles) {
    let sedan = 0;
    let mpv = 0;
    let van = 0;
    let luxurySedan = 0;
    vehicles.forEach((type) => {
        if (type === 0) {
            sedan += 1;
        }
        if (type === 1) {
            mpv += 1;
        }
        if (type === 2) {
            van += 1;
        }
        if (type === 3) {
            luxurySedan += 1;
        }
    });
    function s(t) {
        return t > 1 ? "s" : "";
    }
    return ((sedan !== 0 ? `${sedan} sedan${s(sedan)}` : "") +
        (sedan !== 0 ? (mpv !== 0 || van !== 0 || luxurySedan !== 0 ? ", " : "") : "") +
        (mpv !== 0 ? `${mpv} mpv${s(mpv)}` : "") +
        (mpv !== 0 ? (van !== 0 || luxurySedan !== 0 ? ", " : "") : "") +
        (van !== 0 ? `${van} van${s(van)}` : "") +
        (van !== 0 ? (luxurySedan !== 0 ? ", " : "") : "") +
        (luxurySedan !== 0 ? `${luxurySedan} luxury sedan${s(luxurySedan)}` : ""));
}
//# sourceMappingURL=transformVehiclesToString.js.map